import { Box, Button } from "@mui/material";
import { useTranslation } from "react-i18next";

export const ActionButtons = ({
    onCancel,
    onSubmit,
    onSubmitOptional,
    cancelLabel,
    submitLabel,
    labelOptional,
    disabledSubmit = false,
    disabledCancel = false,
    disabledOptional = false
}) => {
    const { t } = useTranslation();

    const finalCancelLabel = cancelLabel || t("cancel");
    const finalSubmitLabel = submitLabel || t("save");
    const finalSendLabelOptional = labelOptional;

    return (
        <Box sx={{ mt: 2, textAlign: "right" }}>
            {onCancel && (
                <Button
                    variant="contained"
                    color="primary"
                    sx={{ mx: 3, minWidth: 90 }}
                    onClick={onCancel}
                    disabled={disabledCancel}
                >
                    {finalCancelLabel}
                </Button>
            )}
            {onSubmit && (
                <Button
                    variant="contained"
                    onClick={onSubmit}
                    color="success"
                    sx={{ minWidth: 90 }}
                    disabled={disabledSubmit}
                >
                    {finalSubmitLabel}
                </Button>
            )}

            {onSubmitOptional && (
                <Button
                    variant="contained"
                    color="info"
                    sx={{ ml: 3, minWidth: 90 }}
                    onClick={onSubmitOptional}
                    disabled={disabledOptional}
                >
                    {finalSendLabelOptional}
                </Button>
            )}
        </Box>
    );
};
